import { useState, useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { supabase } from "./components/auth/supabaseClient";
import Login from "./components/auth/Login";
import { useAuth } from "./contexts/AuthContext";
import SideNavigationBar from "./components/common/nav";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import track from "./components/common/tracking";

export default function ProtectedRoot() {
  const [isProfileSet, setIsProfileSet] = useState(false);
  const [loading, setLoading] = useState(true);
  const { user, signOut, updateUserMetadata } = useAuth();

  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    if (user) {
      getIsProfileSet();

      track("User Logged In", {
        user_id: user.id,
        email: user.email,
      });
    }
    setLoading(false);
  }, [user]);

  const handleSignOut = async () => {
    await signOut();
  };

  const getIsProfileSet = async () => {
    let { data, error, status } = await supabase
      .from("profiles")
      .select("profile_set")
      .eq("id", await user.id)
      .single();

    console.log("profile data App.js", data);

    if (error) {
      console.log(error);
      navigate("/set-profile");
    } else {
      setIsProfileSet(data.profile_set);
    }
  };

  if (loading) {
    return (
      <div className="grid place-items-center h-screen">
        <AiOutlineLoading3Quarters
          className="animate-spin"
          onClick={() => {
            console.log(user);
          }}
        />
      </div>
    );
  }

  return (
    <div>
      {user && !loading ? (
        <div className="flex flex-row">
          <SideNavigationBar
            className="flex-none"
            hideNavButtons={!isProfileSet}
          />
          <div className="grow flex max-h-screen justify-center mt-6 overflow-y-scroll">
            <Outlet />
          </div>
        </div>
      ) : (
        <Login />
      )}
    </div>
  );
}
